import { Component, OnInit, Injectable, ViewChild, ElementRef } from '@angular/core';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { PaymentPlatform } from '../../models/PaymentPlatform';
import { TransactionType } from '../../models/TransactionType';
import { CustomFilterType } from '../../models/CustomFilterType';
import { PaymentTransactionsService } from '../../services/paymentTransactions.service';
import { PaymentTransactionFilter } from '../../models/PaymentTransactionFilter';
import { PaymentTransaction } from '../../models/PaymentTransaction';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ProductTypesService } from '../../services/productTypes.service';
import { MatDialog } from '@angular/material';
import { TransactionModalComponent } from './transactionModal.component';
import * as moment from 'moment-timezone';
import { ProductStatsModalComponent } from './productStatsModal.component';
import { UsersSiteService } from '../../../shared/services/usersSite.service';


@Component({
  selector: 'app-usersSiteFilter',
  templateUrl: '../templates/paymentTransactionsFilter.component.html'
})

@Injectable()
export class PaymentTransactionsFilterComponent implements OnInit {

  title = 'Payment Transactions';
  DashboardUrl = '';
  inProgress = true;
  paymentPlatforms = [];
  types = [];
  productTypes = [];
  totalAmount: number;
  transactions: PaymentTransaction[] = [];
  selectedCustomFilterType: CustomFilterType;
  platformSubId: String;
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    allowSearchFilter: false,
    itemsShowLimit: 2,
  }
  filter: any;

  constructor(
    private urlService: UrlService,
    private productTypesService: ProductTypesService,
    private paymentTransactionsService: PaymentTransactionsService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private usersSiteService: UsersSiteService) {
    this.paymentPlatforms = Object.values(PaymentPlatform).map(x => ({ id: x, text: x }))
    this.types = Object.values(TransactionType).map(x => ({ id: x, text: x.replace(/([a-z])([A-Z])/g, '$1 $2') }))
    this.selectedCustomFilterType = CustomFilterType.All
  }

  ngOnInit() {
    this.Init();
    this.Filter();
  }

  mergeTransactions(data: PaymentTransaction[]) {
    const merge = this.transactions.concat(data);
    this.transactions = merge.sort((a, b) => a.dateUtc > b.dateUtc ? -1 : 1);
  }

  getText(txt: string) {
    if (txt === "Signals")
      return "Premium";
    return txt;
  }

  Init(): void {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.productTypesService.Get().subscribe(x => this.productTypes = x.map(x => ({ id: x, text: this.getText(x.replace(/([a-z])([A-Z])/g, '$1 $2')) })));
    moment.tz.setDefault("UTC");

    this.filter = {
      from: moment().subtract(7, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
      to: moment().set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
      userEmail: '',
      paymentEmail: '',
      types: [],
      customType: null,
      paymentPlatforms: [],
      productTypes: [],
      platformSubId: ''
    }
  };

  Filter(): void {
    const requestFilter = {
      from: this.filter.from.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
      to: this.filter.to.set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
      userEmail: this.filter.userEmail,
      paymentEmail: this.filter.paymentEmail,
      types: this.filter.types.map(x => x.id),
      customType: this.filter.customType,
      paymentPlatforms: this.filter.paymentPlatforms.map(x => x.id),
      productTypes: this.filter.productTypes.map(x => this.getText(x.id)),
      platformSubId: this.filter.platformSubId
    };

    this.inProgress = true;
    this.transactions = [];
    this.totalAmount = 0;
    this.alertService.removeAll();

    const filter = requestFilter as PaymentTransactionFilter;
    if (filter.userEmail)
      this.usersSiteService.GetByEmail(filter.userEmail).subscribe(user => {
        filter.userId = user.UserId;
        this.paymentTransactionsService.GetByFilterPay(filter).subscribe(data => {
          this.mergeTransactions(data);
          this.calculatePaymentType();
          this.calculateTotalAmount();
          this.inProgress = false;
        });
      });
    else {
      this.paymentTransactionsService.GetByFilterPay(filter).subscribe(x => {
        this.mergeTransactions(x);
        this.calculatePaymentType();
        this.calculateTotalAmount();
        this.inProgress = false;

        if (this.filter.customType !== null) {
          this.transactions = this.transactions.filter(x => x.paymentType === this.filter.customType);
        }
      });
    }
  };

  CustomFilter(customFilterType: CustomFilterType) {

    switch (customFilterType) {
      case CustomFilterType.All:
        this.filter.types = []
        this.filter.customType = null
        this.selectedCustomFilterType = CustomFilterType.All
        break
      case CustomFilterType.NewSubscriptions:
        this.filter.types = [{ id: TransactionType.SubscriptionCreated }, { id: TransactionType.SubscriptionPaid }]
        this.filter.customType = CustomFilterType.NewSubscriptions
        this.selectedCustomFilterType = CustomFilterType.NewSubscriptions
        break
      case CustomFilterType.Renewals:
        this.filter.types = [{ id: TransactionType.SubscriptionCreated }, { id: TransactionType.SubscriptionPaid }]
        this.filter.customType = CustomFilterType.Renewals
        this.selectedCustomFilterType = CustomFilterType.Renewals
        break
      case CustomFilterType.Cancellations:
        this.filter.types = [{ id: TransactionType.SubscriptionCanceled }]
        this.filter.customType = null
        this.selectedCustomFilterType = CustomFilterType.Cancellations
        break
      case CustomFilterType.Expirations:
        this.filter.types = [{ id: TransactionType.SubscriptionExpired }, { id: TransactionType.SubscriptionDeleted }]
        this.filter.customType = null
        this.selectedCustomFilterType = CustomFilterType.Expirations
        break
      case CustomFilterType.Refunded:
        this.filter.types = [{ id: TransactionType.SubscriptionRefunded }]
        this.filter.customType = null
        this.selectedCustomFilterType = CustomFilterType.Refunded
        break
      default:
        return null
    }

    this.Filter()
  }

  ShowStats() {
    this.dialog.open(ProductStatsModalComponent, {});
  }

  getPeriodText(transaction: PaymentTransaction) {
    switch (transaction.subscription.months) {
      case 12:
        return 'Yearly'
      case 3:
        return 'Quarterly'
      case 1:
        return 'Monthly'
      case 0:
        return ''
      default:
        return `${transaction.subscription.months} months`
    }
  }

  getRowColorClass(transaction: PaymentTransaction) {
    switch (transaction.type) {
      case TransactionType.SubscriptionCreated:
      case TransactionType.SinglePayment:
        return 'success';
      case TransactionType.SubscriptionCanceled:
        return 'danger';
      case TransactionType.SubscriptionPaid:
        return 'info';
      case TransactionType.SubscriptionExpired:
      case TransactionType.SubscriptionFailed:
      case TransactionType.SubscriptionRefunded:
        return 'warning';
      default:
        return '';
    }
  }

  showTransactionDetails(transaction: PaymentTransaction) {
    this.dialog.open(TransactionModalComponent, {
      hasBackdrop: true,
      backdropClass: 'fxstreet-modal-backdrop',
      panelClass: 'fxstreet-preview-dialog-panel',
      position: { top: '150px' },
      data: {
        detailsJson: transaction.details
      }
    })
  }

  private calculateTotalAmount() {
    this.totalAmount = 0
    this.transactions.forEach(x => this.totalAmount += x.amount)
  }

  private calculatePaymentType() {
    const length = this.transactions.length;
    for (let i = 0; i < length; i++) {
      if (this.transactions[i].type === TransactionType.SubscriptionPaid) {
        const userTransactions = this.transactions.filter(t => t.userId === this.transactions[i].userId);
        const pos = userTransactions.findIndex(ut => ut.id === this.transactions[i].id);
        if (pos - 1 >= 0) {
          if (userTransactions[pos - 1].type === TransactionType.SubscriptionCreated) {
            this.transactions[i].paymentType = "New Subscription";
            continue;
          }
        }
        if (pos + 1 < userTransactions.length) {
          if (userTransactions[pos + 1].type === TransactionType.SubscriptionCreated) {
            this.transactions[i].paymentType = "New Subscription";
            continue;
          }
        }
        this.transactions[i].paymentType = "Renewal";
      }
    }
  }

  get customFilterType() {
    return CustomFilterType
  }
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/components/scripts/paymentTransactionsFilter.component.ts